import React, { useState, Fragment, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import moment from "moment";
import EventCard from "../../components/cards/EventCard";
import { server } from "../../config";
import axios from "axios";
import Head from "next/head";
import Skeleton from "@mui/material/Skeleton";
import { Navigation, Pagination, Autoplay, FreeMode } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { nanoid } from "nanoid";
import darkTheme from '../../src/theme';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import { useRouter } from 'next/router'
import InputBase from '@mui/material/InputBase';
// import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CatImage from '../../public/images/2.png'
import Image from 'next/image'
import InfiniteScroll from "react-infinite-scroll-component";

const eventsContainer = {
  marginTop: darkTheme.spacing(2.5),
  marginBottom: darkTheme.spacing(2.5),
  [darkTheme.breakpoints.down("md")]: {    
    paddingTop: darkTheme.spacing(3),
  },
  '& h1': {
    fontSize: 60,
    fontWeight: 500,
    marginTop: darkTheme.spacing(3),                 
  },
  '& h2': {
    fontSize: 30,
    fontWeight: 400,
    // marginTop: darkTheme.spacing(2),        
    [darkTheme.breakpoints.down("md")]: {
      marginBottom: darkTheme.spacing(1),
      marginTop: darkTheme.spacing(1),
      fontSize: 20,
    }
  },
  '& h3': {
    fontSize: 16,
    fontWeight: 400,
    color: darkTheme.palette.primary.subTitle,
    marginTop: darkTheme.spacing(1),
    marginBottom: darkTheme.spacing(1),    
  },
  '& h4': {
    fontSize: 16,
    fontWeight: 400,
    color: darkTheme.palette.primary.subTitle,
    marginTop: darkTheme.spacing(1),
    marginBottom: darkTheme.spacing(1),    
  }
};

const calendarFilter = {
  border: `1px solid #3F3E46`,
  borderRadius: 2,
  background: `${darkTheme.palette.background.default}`,
  padding:1,
  justifyContent: 'center',
  textAlign: 'center',
  fontSize: 14,
  cursor: 'pointer',
  fontWeight: 400,   
  height: `50px !important`,
  alignItems: 'center',
  display: 'flex', 
  minWidth: 100,
  color: `#C3C3C3`,
  [darkTheme.breakpoints.down("sm")]: {
    padding: 0.5,    
    fontSize: 12,
    minWidth: 60,
  }
};

const calendarFilterActive = {
  border: `1px solid ${darkTheme.palette.primary.main}`,
  borderRadius: 2,
  background: `${darkTheme.palette.primary.main}`,
  padding:1, 
  justifyContent: 'center',
  textAlign: 'center',
  fontSize: 14,
  cursor: 'pointer',
  fontWeight: 400,  
  height: `50px !important`,  
  alignItems: 'center',
  display: 'flex',
  minWidth: 100,
  color: `${darkTheme.palette.background.default}`,
  [darkTheme.breakpoints.down("sm")]: {
    padding: 0.5,      
    fontSize: 12,
    minWidth: 60,    
  }
};

const clubTypeFilter = {
  border: `1px solid #3F3E46`,
  borderRadius: 2,
  background: `${darkTheme.palette.background.default}`,
  padding: `2px 12px 2px 8px !important`, 
  textAlign: 'center',
  fontSize: 14,
  cursor: 'pointer',
  fontWeight: 400,  
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  // marginRight: 2,  
  height: `40px !important`,
  color: `#C3C3C3`,
  [darkTheme.breakpoints.down("sm")]: {       
    fontSize: 12,
  }
};

const clubTypeFilterActive = {
  border: `1px solid ${darkTheme.palette.primary.main}`,
  borderRadius: 2,
  background: `${darkTheme.palette.primary.main}`,
  padding: `2px 12px 2px 8px !important`, 
  textAlign: 'center',
  fontSize: 14,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  // marginRight: 2,
  fontWeight: 400,  
  height: `40px !important`,
  color: `${darkTheme.palette.background.default}`,
  [darkTheme.breakpoints.down("sm")]: {        
    fontSize: 12,
  }
};

const calendarFilterDate = {
  border: `1px solid #3F3E46`,
  borderRadius: 2,
  background: `${darkTheme.palette.background.default}`,
  padding: 0.35, 
  height: `44px !important`,
  textAlign: 'center',  
  cursor: 'pointer',  
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width:60,
  '& h5': {
    fontSize: 12,
    color: darkTheme.palette.primary.location,
  },
  '& h6': {
    fontSize: 16,
    color: darkTheme.palette.primary.dates,
  }
};

const calendarFilterDateActive = {
  border: `1px solid ${darkTheme.palette.primary.main}`,
  borderRadius: 2,
  background: `${darkTheme.palette.primary.main}`,
  padding: 0.35,  
  height: `44px !important`,
  textAlign: 'center',  
  cursor: 'pointer',  
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',  
  width:60,
  '& h5': {
    fontSize: 12,
    color: darkTheme.palette.background.default,
  },
  '& h6': {
    fontSize: 16,
    color: darkTheme.palette.background.default,
  }
};

const areaNameStyleSelected = {
  color: `${darkTheme.palette.background.default} !important`,
  backgroundColor: `${darkTheme.palette.primary.main} !important`,
  textTransform: 'capitalize',
  fontWeight: 100,
  cursor: 'pointer',
  fontSize: 12,
  border: `1px solid ${darkTheme.palette.primary.main}`,
  borderRadius: 15,
  padding: `4px 8px`,
  [darkTheme.breakpoints.down("md")]: {        
    fontSize: 12,
  }
}

const areaNameStyle = {
  color: '#C3C3C3',
  textTransform: 'capitalize',
  fontWeight: 100,
  cursor: 'pointer',
  fontSize: 12,
  border: `1px solid #5D5D5D`,
  borderRadius: 15,
  padding: `4px 8px`,
  [darkTheme.breakpoints.down("md")]: {        
    fontSize: 12,
  }
}

export const getStaticProps = async function (context) {
  try {
    let posts = "";
    let banners = "";  
    let current_date = new Date();
    let current_date_new = moment(current_date).format("YYYY-MM-DD");
    let city = context.params.cityTitle.toString();        

    await axios
      .get(
        `${server}/api/global/events?start=0&limit=12&page=allEventsNoLimit&dt=${current_date_new}&city=${city}`,
        {
          headers: {
            "x-auth-token": process.env.JWT_TOKEN,
          },
        }
      )
      .then((response) => {
        if (response.status == 200) {
          posts = response.data.result;
        }
      })
      .catch(err => {
        console.log(err);
      })
  
    await axios
      .get(`${server}/api/banners/events?city=${city}`, {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          banners = response.data.result;
        }
      })
      .catch(err => {
        console.log(err);
      })
  
      return { 
        props: { posts: posts, date: current_date_new, banners: banners, city:city },
        revalidate: 1
      };
  } catch (e) {
    console.log(e)
    // return {notFound: true}
  }
};

export const getStaticPaths = async function () {
  try {
    const res = await axios.get(`${server}/api/cities/list`, {
      headers: {
        "x-auth-token": process.env.JWT_TOKEN,
      },
    });
  
    const paths = res.data.result.map((e) => ({
      params: {
        cityTitle: e.name,
      },
    }));
    return { paths, fallback: "blocking" };
  } catch (e) {
    console.log(e);
  }
}  

function All(props) {  
  
  const [dataLimit, setDataLimit] = useState(12);
  const [eventsListDynamic, setEventsListDynamic] = useState(props.posts.length > 0 ? props.posts.slice(0, dataLimit) : props.posts)
  const [eventsList, setEventsList] = useState(props.posts);  
  const [eventsListAll, setEventsListAll] = useState(props.posts);    
  const [categories, setCategories] = useState([]);             
  const [searchKey, setSearchKey] = useState("");
  const [loading, setLoading] = useState(props.posts ? false : true);
  const [areaNames, setAreaNames] = useState([]);   
  const [current_date, setCurrent_date] = useState(moment(props.date).format("YYYY-MM-DD")); 
  const [dayType, setDayType] = useState('');
  const [eventType, setEventType] = useState('');
  const [showOtherDates, setShowOtherDates] = useState(false);  
  const [selectedArea, setSelectedArea] = useState('');
  const [moreLoading, setMoreLoading] = useState(true)

  const Router = useRouter();

  const handleFilterDates = async(type) => {        
    // setShowOtherDates(showOtherDates);
    setDayType(type);
    if (type == 'dates') {      
      setShowOtherDates(!showOtherDates);
      // alert(showOtherDates)
      setCategories([])
      setAreaNames([])      
      let selectedDate1 = moment(props.date).format("YYYY-MM-DD");
      let selectedDate2 = moment(props.date).format("YYYY-MM-DD");      
      var currentDateNew = moment(props.date).format("YYYY-MM-DD");
      var currentDate = moment();
      var weekStart = currentDate.clone().startOf('week');
      var weekEnd = currentDate.clone().endOf('week');
      selectedDate1 = moment(weekStart).add(1, 'days').format("YYYY-MM-DD") >= currentDateNew ? moment(weekStart).add(1, 'days').format("YYYY-MM-DD") : currentDateNew;
      selectedDate2 = moment(weekEnd).add(1, 'days').format("YYYY-MM-DD");
      setCurrent_date(selectedDate1); 
      handleFilterEvents(selectedDate1,selectedDate2)            
      if (!showOtherDates) {
        setDayType('dates')
      } else {
        setDayType('')
      }
    } else {
      
      setShowOtherDates(false)
      let selectedDate1 = moment(props.date).format("YYYY-MM-DD");
      let selectedDate2 = moment(props.date).format("YYYY-MM-DD");
      if (type == 'today') {
          selectedDate1 = moment(props.date).format("YYYY-MM-DD")
          selectedDate2 = moment(props.date).format("YYYY-MM-DD")
        } else if (type == 'tomorrow') {
          selectedDate1 = moment(props.date).add(1, 'days').format("YYYY-MM-DD")
          selectedDate2 = moment(props.date).add(1, 'days').format("YYYY-MM-DD")
      } else if (type == 'week') {
        var currentDateNew = moment(props.date).format("YYYY-MM-DD");
        var currentDate = moment();
        var weekStart = currentDate.clone().startOf('week');
        var weekEnd = currentDate.clone().endOf('week');
        selectedDate1 = moment(weekStart).add(1, 'days').format("YYYY-MM-DD") >= currentDateNew ? moment(weekStart).add(1, 'days').format("YYYY-MM-DD") : currentDateNew;
        selectedDate2 = moment(weekEnd).add(1, 'days').format("YYYY-MM-DD");
      }
      setCurrent_date(selectedDate1); 
      handleFilterEvents(selectedDate1,selectedDate2)
    }    
  };

  const handleFilterEvents = async (date1, date2) => {        
    let posts = null;
    setLoading(true);
    await axios
      .get(
        // `${server}/api/global/events?start=0&limit=12&page=allEventsNew&dt1=${date1}&dt2=${date2}&city=${props.city}`,
        `/api/global/events?start=0&limit=12&page=allEventsNew&dt1=${date1}&dt2=${date2}&city=${props.city}`,
        {
          headers: {
            "x-auth-token": process.env.JWT_TOKEN,
          },
        }
      )
      .then((response) => {
        if (response.status == 200) {
          posts = response.data.result;
        }
      })
      .catch(err => {
        console.log(err);
      });
    setEventsList(posts)
    setEventsListAll(posts)
    setEventsListDynamic(posts)
    setEventType('')
    setSelectedArea('');
    setLoading(false)
  }

  const handleFilterEventsIndividual = async (e, date) => {
    e.preventDefault()
    setDayType('')    
    setCurrent_date(date); 
    handleFilterEvents(date,date)
  }


  const handleFilterTypes = async (type) => {       
    let res1 = await eventsListAll.filter((item) => {
      return item.event_type == type
    });
    setEventType(type);
    setEventsList(res1);
    setEventsListDynamic(res1);
    const res2 = Object.values(res1.reduce((a, { area_name }) => {
      a[area_name] = { area_name }
      return a;
    }, {}));
    setAreaNames(res2);
    setSelectedArea('');
  };
  
  
  function getSearchItems(event) {
    const keyword = event.target.value;
    setSearchKey(keyword);    
    setSelectedArea('');
    setLoading(true)
    axios
      .get(
        // `${server}/api/global/allEvents?keyword=${keyword}&dt=${current_date}&page=eventsAll&city=${props.city}`,
        `/api/global/allEvents?keyword=${keyword}&dt=${current_date}&page=eventsAll&city=${props.city}`,
        {
          headers: {
            "x-auth-token": process.env.JWT_TOKEN,
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          const newPosts = res.data;                    
          setEventsList(newPosts.result);                       
          setEventsListDynamic(newPosts.result);
          setLoading(false)
        }else{
          setLoading(false)
        }
      })
      .catch(err => {
        console.log(err);
      })
  }
  
  useEffect(() => { 
    
    const res1 = Object.values(eventsListAll.reduce((a, { area_name }) => {
      a[area_name] = { area_name }
      return a;
    }, {}));
    setAreaNames(res1);
    eventsListAll.sort();
    // const res2 = Object.values(eventsListAll.reduce((a, { event_type }) => {
    //   a[event_type] = { event_type }
    //   return a;
    // }, {}))

    const a = eventsListAll.map(e => {
      return {
        event_type: e.event_type,
        catImage: e.catImage
      }
    })
    
    // console.log(a);

    const res2 = a.filter((value, index, self) =>
      index === self.findIndex((t) => (
        t.event_type === value.event_type
      ))
    )
    // console.log(res2);
    setCategories(res2);
    categories.sort();
    
  }, [eventsListAll]);

   const getAreaEventsHandler = async(area) => { 
    
    let res1 = await eventsListAll.filter((item) => {
      return item.area_name == area
    });
    setSelectedArea(area)
    setEventsList(res1);
    setEventsListDynamic(res1);
  }

  let dates = [];
  dates[0] = '';
  for (let i = 2; i < 13; i++) {
    var date = new Date();
    if (i == 1) {
      dates[i] = moment(date.setDate(date.getDate())).format("YYYY-MM-DD");
      dates[i+1] = moment(date.setDate(date.getDate() + i)).format("YYYY-MM-DD");
    } else {
      dates[i+1] = moment(date.setDate(date.getDate() + i)).format("YYYY-MM-DD");
    }
  }  


  let skeletonCards = Array(12).fill(0); 
  let skeletonCards2 = Array(4).fill(0); 

  const EVENT_TITLE_MAX_LENGTH = 20;

  const fetchMoreData = () => {
    setTimeout(() => {
      const newLimit = dataLimit + 12
      const newData = eventsList.slice(0, newLimit)
      setEventsListDynamic(newData)
      setDataLimit(newLimit)
      if (eventsList.length === newData.length) {
        setMoreLoading(false);
      }
    }, 500);
  }

  return (
    <Fragment>
      <Head>
        <title>Upcoming Live Music Events, DJ Night, Standup Comedy from pubs & Nightclubs{props.city ? ' in '+props.city.charAt(0).toUpperCase() +props.city.slice(1) : ''} - Clubr </title>
        <meta name="description" content={`Discover the best upcoming live Music events, DJ nights, and Standup comedy from pubs, Nightclubs, breweries and Resto Bars. Book online for tickets, Reservations, Vip Tables and Guestlists only on Clubr${props.city ? ' in '+props.city.charAt(0).toUpperCase() +props.city.slice(1) : ''}.`}></meta>
        <meta property="og:title" content={`Upcoming Live Music Events, DJ Night, Standup Comedy from pubs & Nightclubs${props.city ? ' in '+props.city.charAt(0).toUpperCase() +props.city.slice(1) : ''} - Clubr`}></meta>
        <meta property="og:description" content={`Discover the best upcoming live Music events, DJ nights, and Standup comedy from pubs, Nightclubs, breweries and Resto Bars. Book online for tickets, Reservations, Vip Tables and Guestlists only on Clubr ${props.city ? ' in '+props.city.charAt(0).toUpperCase() +props.city.slice(1) : ''}.`}></meta>
        <meta property="og:image" content={props.banners[0] ? props.banners[0].img_path : ''}></meta>
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Clubr" />
        <meta property="og:url" content={`https://clubr.in/all-events`} />
        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta name="twitter:site" content="@Clubr14"></meta>
        <meta name="twitter:creator" content="@Clubr14"></meta>
        <meta name="twitter:title" content={`Upcoming Live Music Events, DJ Night, Standup Comedy from pubs & Nightclubs - Clubr`}></meta>
        <meta name="twitter:description" content={`Discover the best upcoming live Music events, DJ nights, and Standup comedy from pubs, Nightclubs, breweries and Resto Bars. Book online for tickets, Reservations, Vip Tables and Guestlists only on Clubr.`}></meta>
        <meta name="twitter:image" content={props.banners[0] ? props.banners[0].img_path : ''}></meta>
      </Head>
      <div className="main_sec">                  
        <Typography component="div" sx={eventsContainer}>
          <Grid container spacing={3} sx={{mb:3}}>
            <Grid item xl={8} lg={8} md={8} sm={12} xs={12} className="desktopMode" alignSelf="center">
              <Typography variant="h1">Explore Events</Typography>                
              <Typography variant="h3">Book Tables from Best Pubs, Nightclubs, Breweries, Restobars and Live Music Venues</Typography>
            </Grid>
          <Grid item xl={4} lg={4} md={4} sm={12} xs={12} alignSelf="center">              
              <Box className="searchBox" sx={{ height: { md: '50px',sm:'40px'}}}>
                <Typography component="span" sx={{mt:1, pl:2}}><SearchIcon /></Typography>
                <InputBase
                  sx={{ ml: 1, flex: 1, fontWeight:100 }}
                  placeholder="Search Here"
                  inputProps={{ 'aria-label': 'Search Here' }}
                    onChange={getSearchItems}
                />                
              </Box>                
            </Grid>
          </Grid>

          {/* Desktop Version */}
          <Typography component="div" className="desktopMode">             
              <Grid container spacing={2} sx={{ mb:2 }}>
                <Grid item xs={3} sm={2} md={1.5} lg={1.5} xl={1.5}>
                  <Typography component="p" onClick={() => handleFilterDates('week')} sx={dayType == 'week' ? calendarFilterActive : calendarFilter} style={{height:`50px !important`}}>This Week</Typography>
                </Grid>
                <Grid item xs={3} sm={2} md={1.5} lg={1.5} xl={1.5}>
                  <Typography component="p" onClick={() => handleFilterDates('today')} sx={dayType == 'today' ? calendarFilterActive : calendarFilter} style={{height:`50px !important`}}>Today</Typography>
                </Grid>
                <Grid item xs={3} sm={2} md={1.5} lg={1.5} xl={1.5}>
                  <Typography component="p" onClick={() => handleFilterDates('tomorrow')} sx={dayType == 'tomorrow' ? calendarFilterActive : calendarFilter} style={{height:`50px !important`}}>Tomorrow</Typography>
                </Grid>
                <Grid item xs={3} sm={2} md={1.5} lg={1.5} xl={1.5}>
                  <Typography component="p" onClick={() => handleFilterDates('dates')} sx={dayType == 'dates' ? calendarFilterActive : calendarFilter} style={{ justifyContent: 'flex-start',height:`50px !important` }}>
                    <Stack display="flex" flexDirection="row" justifyContent="flex-start" alignItems="start">
                      <InsertInvitationIcon sx={{ fontSize: 22, mr: 1, mt: 0.3 }} />
                      <Stack display="flex" flexDirection="column" justifyContent="space-between" alignItems="center">
                        <Typography component="p" sx={{ lineHeight: 1, fontSize:14}}>Choose</Typography>
                        <Typography component="p" sx={{ lineHeight: 1, fontSize:14}}>
                          Date&nbsp; <ArrowForwardIcon sx={{ fontSize: 14 }} />
                        </Typography>
                      </Stack>
                    </Stack>
                  </Typography>
                </Grid>                
                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                  <Grid container spacing={0} sx={{ mb: 2 }}>
                    {showOtherDates && (
                    <Swiper
                        className="autoWidthSlider"
                        modules={[Navigation, Pagination]}
                        spaceBetween={15}
                        navigation={true}
                        autoplay={false}
                        loop={false}
                        slidesPerView={"auto"}                        
                      >
                        {dates.map((item) => (
                          <Grid item xs={2} key={nanoid(30)}>
                            {item != '' && (
                              <SwiperSlide key={nanoid(30)}>
                                {current_date == item ? (
                                  <Stack display="flex" flexDirection="column" justifyContent="center" onClick={(e) => handleFilterEventsIndividual(e, item)} sx={calendarFilterDateActive}  style={{height:`50px !important`}}>
                                    <Typography variant="h5">{moment(item).format("ddd")}</Typography>
                                    <Typography variant="h6">{moment(item).format("DD")}</Typography>
                                  </Stack>
                                ) : (
                                  <Stack display="flex" flexDirection="column" justifyContent="center" onClick={(e) => handleFilterEventsIndividual(e, item)} sx={calendarFilterDate}  style={{height:`50px !important`}}>
                                    <Typography variant="h5">{moment(item).format("ddd")}</Typography>
                                    <Typography variant="h6">{moment(item).format("DD")}</Typography>
                                  </Stack>
                                )}
                              </SwiperSlide>
                            )}
                          </Grid>
                        ))}
                      </Swiper>
                    )}
                  </Grid>
                </Grid>              
            </Grid>              
          </Typography>

          {/* Mobile Version */}
          <Typography component="div" className="mobileMode"> 
            {!showOtherDates ? (
              <Grid container spacing={2} sx={{ mb:{xs:2, sm:2, md:2, lg:2, xl:2} }}>
                <Grid item xs={3.5} sm={2} md={1.5} lg={1.5} xl={1.5}>
                  <Typography component="p" onClick={() => handleFilterDates('week')} sx={dayType == 'week' ? calendarFilterActive : calendarFilter} style={{height:`50px !important`}}>This Week</Typography>
                </Grid>
                <Grid item xs={2.5} sm={2} md={1.5} lg={1.5} xl={1.5}>
                  <Typography component="p" onClick={() => handleFilterDates('today')} sx={dayType == 'today' ? calendarFilterActive : calendarFilter} style={{height:`50px !important`}}>Today</Typography>
                </Grid>
                <Grid item xs={2.5} sm={2} md={1.5} lg={1.5} xl={1.5}>
                  <Typography component="p" onClick={() => handleFilterDates('tomorrow')} sx={dayType == 'tomorrow' ? calendarFilterActive : calendarFilter} style={{height:`50px !important`}}>Tomorrow</Typography>
                </Grid>
                <Grid item xs={3.5} sm={2} md={1.5} lg={1.5} xl={1.5}>
                  <Typography component="p" onClick={() => handleFilterDates('dates')} sx={dayType == 'dates' ? calendarFilterActive : calendarFilter} style={{ justifyContent: 'flex-start',height:`50px !important` }}>
                    <Stack display="flex" flexDirection="row" justifyContent="flex-start" alignItems="start">
                      <InsertInvitationIcon sx={{ fontSize: 22, mr: 1, mt: 0.3 }} />
                      <Stack display="flex" flexDirection="column" justifyContent="space-between" alignItems="center">
                        <Typography component="p" sx={{ lineHeight: 1, fontSize: 12 }}>Choose</Typography>
                        <Typography component="p" sx={{ lineHeight: 1, fontSize: 12 }}>
                          Date&nbsp; <ArrowForwardIcon sx={{ fontSize: 14 }} />
                        </Typography>
                      </Stack>
                    </Stack>
                  </Typography>
                </Grid>                              
            </Grid>  
            ):(                       
              <Grid container spacing={0} sx={{ mb: 3 }}>
                <Swiper
                  modules={[Navigation, Pagination]}
                  spaceBetween={5}
                  navigation={false}
                  autoplay={false}
                  loop={false}
                  slidesPerView={5}
                  activeIndex={3}
                  initialSlide={3}
                  breakpoints={{
                    1023: {
                      width: 1023,
                      slidesPerView: 5,
                    },
                    990: {
                      width: 990,
                      slidesPerView: 5,
                    },
                    768: {
                      width: 768,
                      slidesPerView: 5,
                    },
                    425: {
                      width: 425,
                      slidesPerView: 4,
                    },
                  }}
                >
                  <SwiperSlide>
                    <Grid item>
                      <Typography component="p" onClick={() => handleFilterDates('week')} sx={dayType == 'week' ? calendarFilterActive : calendarFilter}>This Week</Typography>
                    </Grid>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Grid item>
                      <Typography component="p" onClick={() => handleFilterDates('today')} sx={dayType == 'today' ? calendarFilterActive : calendarFilter}>Today</Typography>
                    </Grid>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Grid item>
                      <Typography component="p" onClick={() => handleFilterDates('tomorrow')} sx={dayType == 'tomorrow' ? calendarFilterActive : calendarFilter}>Tomorrow</Typography>
                    </Grid>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Grid item>
                      <Typography component="p" onClick={() => handleFilterDates('dates')} sx={dayType == 'dates' ? calendarFilterActive : calendarFilter} style={{ justifyContent: 'flex-start' }}>
                        <Stack display="flex" flexDirection="row" justifyContent="flex-start" alignItems="start">
                          <Stack display="flex" flexDirection="column" justifyContent="space-between" alignItems="center">
                            <Typography component="p" sx={{ fontSize: 12 }}>Choose Date&nbsp;<ArrowForwardIcon sx={{ fontSize: 14 }} /></Typography>
                          </Stack>
                        </Stack>
                      </Typography>
                    </Grid>
                  </SwiperSlide>
                  {showOtherDates && (
                    <>
                      {dates.map((item) => (
                        <Grid item key={nanoid(30)}>
                          {item != '' && (
                            <SwiperSlide key={nanoid(30)}>
                              {current_date == item ? (
                                <Stack display="flex" flexDirection="column" justifyContent="center" onClick={(e) => handleFilterEventsIndividual(e, item)} sx={calendarFilterDateActive} >
                                  <Typography variant="h5">{moment(item).format("ddd")}</Typography>
                                  <Typography variant="h6">{moment(item).format("DD")}</Typography>
                                </Stack>
                              ) : (
                                <Stack display="flex" flexDirection="column" justifyContent="center" onClick={(e) => handleFilterEventsIndividual(e, item)} sx={calendarFilterDate} >
                                  <Typography variant="h5">{moment(item).format("ddd")}</Typography>
                                  <Typography variant="h6">{moment(item).format("DD")}</Typography>
                                </Stack>
                              )}
                            </SwiperSlide>
                          )}
                        </Grid>
                      ))}
                    </>
                  )}
                </Swiper>
              </Grid>
            )}
          </Typography>

          {/* Categories */}
          {!searchKey ? (
            <Typography component="div" sx={{ pb: 3 }}>
              <Swiper
                className="autoWidthSlider"
                modules={[Navigation, Pagination]}
                spaceBetween={15}
                navigation={false}
                autoplay={false}
                loop={false}
                slidesPerView="auto"
              >
                {categories.map((item) => (
                  <SwiperSlide key={nanoid(30)}>
                    <Typography component="p" sx={eventType == item.event_type ? clubTypeFilterActive : clubTypeFilter} onClick={() => handleFilterTypes(item.event_type)} style={{ mr: 1, textAlign: 'left', p:2 }}>
                      {/* <p>{item.catImage}--</p> */}
                      {/* {item.catImage ? (
                        <Image src={item.catImage} width="40" height="40" alt="..." style={{ borderRadius: 8 }} />
                      ) : (
                        <Image src={CatImage} width="40" height="40" alt="..." style={{ borderRadius: 8 }} />
                      )} */}
                      {/* <Typography component="p" sx={{ ml: 1, wordBreak: 'keep-all', fontSize: 13 }}> */}
                        {(item.event_type.length >= EVENT_TITLE_MAX_LENGTH
                          ? (item.event_type).substring(0, EVENT_TITLE_MAX_LENGTH) +
                          "..."
                          : item.event_type
                        )}
                      {/* </Typography> */}
                    </Typography>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Typography>
          ):('')}

          {/* Areas */}
          {areaNames.length > 1 && eventType ? (
            <Typography component="div" sx={{ width: '100%', mb:5 }}>                          
              <Grid container spacing={3}>
              <Grid item xs={2.5} sm={1.5} md={1} lg={1} xl={1} ><Typography component="p" sx={{color:'#C0C0C0', fontSize:{md:16, sm:14, xs:12}}}>Locations:</Typography></Grid>
              <Grid item xs={9.5} sm={10.5} md={11} lg={11} xl={11}>
                  <Swiper
                  className="autoWidthSlider"
                  modules={[Navigation, Pagination]}
                  spaceBetween={10}
                  navigation={false}
                  autoplay={false}
                  loop={false}
                  slidesPerView="auto"                                  
                >
                  {areaNames.map(item => {
                    return (
                    <>
                      {item.area_name ? (                        
                        <SwiperSlide key={nanoid(20)}>
                          {selectedArea == item.area_name.trim() ? (
                            <Typography component="p" onClick={() => getAreaEventsHandler(item.area_name)} key={nanoid(30)} sx={areaNameStyleSelected}>
                              {item.area_name}
                            </Typography>
                            ) : (                                                              
                              <Typography component="p" onClick={() => getAreaEventsHandler(item.area_name)} key={nanoid(30)} sx={areaNameStyle}>
                                {item.area_name}
                              </Typography>                                
                          )}
                          </SwiperSlide>                        
                        ) : ('')}
                    </>
                  )
                })}
                </Swiper>
                </Grid>
              </Grid>
            </Typography>            
          ) : ('')}  
 
          <Typography variant="h2" sx={{mb:2}}>{ eventType ? '"'+eventType+'"' : ''} Upcoming Gigs </Typography>                                                         
          {!loading ? (
            <InfiniteScroll
              scrollThreshold={0.6}
              style={{ overflow: "hidden" }}
              dataLength={eventsListDynamic.length}
              next={fetchMoreData}
              hasMore={true}
              loader={<></>}
              endMessage={<></>}
            >
              <Typography component="div" style={{width:'100% !important'}}>
                  <Grid container spacing={3} >                                      
                    {eventsListDynamic.map((event, index) => (
                      <Grid item  xl={3} lg={3} md={4} sm={6} xs={12} key={nanoid(30)}>
                        <EventCard data={event} key={event.id} />
                      </Grid>     
                    ))}                                      
                  </Grid>
                </Typography>
          </InfiniteScroll>
          ) : (
              
              <Typography component="div" sx={{ pb: 3 }}>
                <Grid container spacing={1.5}>
                  {skeletonCards.map((index) => (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={4}
                      lg={3}
                      xl={3}
                      key={nanoid(30)}
                    >
                      <Skeleton
                        variant="rectangular"
                        height={300}
                        sx={{ borderRadius: "20px" }}
                        key={"sk" + index}
                      />
                      <Stack sx={{ mt: 3 }}>
                        <Skeleton variant="h3" />
                      </Stack>
                      <Stack
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "row",
                          mt: 3,
                          mb: 3,
                        }}
                      >
                        <Skeleton width="40%" variant="body1" />
                        <Skeleton width="40%" variant="body1" />
                      </Stack>
                    </Grid>
                  ))}
                </Grid>
              </Typography>
              )}          

            {eventsListDynamic.length > 0 && moreLoading ? (
              <Typography component="div" sx={{ pb: 3 }}>
                    <Grid container spacing={1.5}>
                      {skeletonCards2.map((index) => (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={4}
                          lg={3}
                          xl={3}
                          key={nanoid(30)}
                        >
                          <Skeleton
                            variant="rectangular"
                            height={300}
                            sx={{ borderRadius: "20px" }}
                            // key={"sk" + index}
                          />
                          <Stack sx={{ mt: 3 }}>
                            <Skeleton variant="h3" />
                          </Stack>
                          <Stack
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              flexDirection: "row",
                              mt: 3,
                              mb: 3,
                            }}
                          >
                            <Skeleton width="40%" variant="body1" />
                            <Skeleton width="40%" variant="body1" />
                          </Stack>
                        </Grid>
                      ))}
                    </Grid>
                  </Typography>
            ) : (
              <Typography component="div" textAlign="center" sx={{ my: 7 }}>
                <Stack display="flex" alignItems="center" flexDirection="row" justifyContent="center">
                  <img src="../images/events-end.png" alt="" style={{ 'width': 30 }} />&nbsp;
                  <Typography component="span" style={{ "fontSize":16, fontWeight:100, color: '#979797' }}>End of Search results for Upcoming Music Events</Typography>
                </Stack>
              </Typography>                  
            )
          }

          </Typography>
      </div>
    </Fragment>
  );
}

export default All;



